module.exports = __webpack_public_path__ + "img/ic-interieur8h.c98de419.svg";